export const environment = {
  production: false,
  // apiURL: 'http://localhost:3000/api/v1/',
  apiURL: 'https://ngshop-backend.onrender.com/api/v1/',
};
